<template>
    <v-layout align-top justify-center row wrap>
        <v-flex xs12 class="pa-2">
            <span class="body-2">Otrok {{ displayIndex }}</span>
        </v-flex>
        <v-flex xs12 sm7 class="pa-2">
            <date-picker v-model="value.date_of_birth" label="Datum rojstva" min_years="-1" />
        </v-flex>
        <v-flex xs6 sm4 class="pa-2">
            <gender-selection-field label="" v-model="value.gender"></gender-selection-field>
        </v-flex>
        <v-flex xs6 sm1 class="pa-2">
            <v-btn small text fab @click="removeChild">X</v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import DatePicker from "../components/DatePicker";
    import GenderSelectionField from "./GenderSelectionField";

    export default {
        name: "ChildPersonalData",
        props: {
            value: {
                type: Object,
                required: true
            },
            index: {
                type: Number,
            }
        },
        components: {GenderSelectionField, DatePicker},
        computed: {
            displayIndex(){
                return this.index + 1;
            }
        },
        watch: {
            value() {
                this.$emit('input', this.value);
            }
        },
        methods: {
            removeChild(){
                this.$emit('remove', this.index);
            }
        }
    }
</script>

<style scoped>

</style>